import React, { useState, useEffect } from "react";
import './FinalizadoView.css';
import logo from '../img/logo_m.png';



const ESTAGIOS = {
  1: { nome: "Recebida", cor: "#757575" },
  2: { nome: "Em análise", cor: "#1976d2" },
  3: { nome: "Analista", cor: "#0288d1" },
  4: { nome: "Médico", cor: "#8e24aa" },
  5: { nome: "Retornou Benef.", cor: "#fbc02d" },
  6: { nome: "Aprovada", cor: "#43a047" },
  7: { nome: "Recusada", cor: "#e53935" },
  8: { nome: "Concluída", cor: "#388e3c" }
};
function FinalizadoView() {
  const [propostas, setPropostas] = useState([]);
  //const [estagios, setEstagios] = useState([]);
  const [busca, setBusca] = useState("");
  //const [estagioSel, setEstagioSel] = useState("");
  const [pagina, setPagina] = useState(1);
  const [expandida, setExpandida] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const temProximaPagina = propostas.length === 10;
  const [reload, setReload] = useState(0);
  const handleReload = () => setReload(r => r + 1);
  

function baixarContrato(idProposta) {
  window.open(`https://gerencial.vionia.com.br/api/contrato/${idProposta}`, "_blank");
}



  useEffect(() => {
    setCarregando(true);
    const params = new URLSearchParams({
      page: pagina,
      per_page: 10,
      estagio: 8,
      
      ...(busca && { busca }),
      //...(estagioSel && { estagio: estagioSel }),
    });
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios?${params}`)
      .then(r => r.json())
      .then(setPropostas)
      .catch(() => setPropostas([]))
      .finally(() => setCarregando(false));
  }, [pagina, busca, reload]);

  // funções auxiliares
  const formatData = d => {
    if (!d) return "";
    if (/^\d{8}$/.test(d)) {
      return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
    }
    const dt = new Date(d);
    return isNaN(dt.getTime()) ? "" : dt.toLocaleDateString();
  };

  // calcula idade, retorna "" se for inválido ou negativa
  const calcularIdade = (data) => {
    if (!data) return "";

    let dia, mes, ano;
    if (/^\d{8}$/.test(data)) { // formato 01011967
      dia = parseInt(data.slice(0, 2), 10);
      mes = parseInt(data.slice(2, 4), 10) - 1;
      ano = parseInt(data.slice(4, 8), 10);
    } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(data)) { // formato 01/01/1967
      const parts = data.split("/");
      dia = parseInt(parts[0], 10);
      mes = parseInt(parts[1], 10) - 1;
      ano = parseInt(parts[2], 10);
    } else {
      return "";
    }

    const nascimento = new Date(ano, mes, dia);
    if (
      nascimento.getFullYear() !== ano ||
      nascimento.getMonth() !== mes ||
      nascimento.getDate() !== dia
    ) {
      return "";
    }
    const hoje = new Date();
    let idade = hoje.getFullYear() - ano;
    if (
      hoje.getMonth() < mes ||
      (hoje.getMonth() === mes && hoje.getDate() < dia)
    ) {
      idade--;
    }
    return idade >= 0 ? idade : "";
  };

  return (
    <div>
      <h2 style={{ marginBottom: 16 }}>Propostas</h2>
      <div style={{ display: "flex", gap: 2, marginBottom: 20 }}>
        <input
          style={{ flex: 2, padding: 8, borderRadius: 8, border: "1px solid #ccc" }}
          placeholder="Buscar por nome ou CPF do titular"
          value={busca}
          onChange={e => { setBusca(e.target.value); setPagina(1); }}
        />
        
      </div>
      <table className="pv-resume-table" style={{ marginBottom: 24 }}>
        <thead>
          <tr>
            <th>Proposta</th>
            <th>Titular</th>
            <th>CPF</th>
            <th>Data Início</th>
            <th>Vendedor</th>
            <th>Corretora</th>
            <th>Analista</th>
            <th>Médico</th>
            <th>Estágio</th>
            <th>Portabilidade</th>
            <th>Contrato</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {carregando ? (
            <tr>
              <td colSpan={12} style={{ textAlign: "center", padding: 32, color: "#888" }}>
                Carregando...
              </td>
            </tr>
          ) : propostas.length === 0 ? (
            <tr>
              <td colSpan={12} style={{ textAlign: "center", padding: 32, color: "#888" }}>
                Nenhuma proposta encontrada.
              </td>
            </tr>
          ) : (
            propostas.map((p) => (
              <React.Fragment key={p.id}>
                <tr>
                  <td>{p.id}</td>
                  <td>{p.titular || p.nome}</td>
                  <td>{p.cpf}</td>
                  <td>{p.data_inicio ? new Date(p.data_inicio).toLocaleDateString() : ""}</td>
                  <td>{p.vendedor}</td>
                  <td>{p.corretora}</td>
                  <td>{p.analista_nome || p.Analista || "-"}</td>
                  <td>{p.medico_nome || p.medico || "-"}</td>
                  <td>
                    {ESTAGIOS[p.Estagio] ? (
                      <span
                        className="pv-badge-estagio"
                        style={{
                          background: ESTAGIOS[p.Estagio].cor,
                          color: "#fff",
                          borderRadius: 12,
                          padding: "2px 12px",
                          fontSize: 13,
                          fontWeight: 600,
                          marginLeft: 2,
                          display: "inline-block",
                          minWidth: 90,
                          textAlign: "center"
                        }}
                        title={ESTAGIOS[p.Estagio].nome}
                      >
                        {ESTAGIOS[p.Estagio].nome}
                      </span>
                    ) : (
                      <span>-</span>
                    )}
                  </td>

                  <td>{p.Portabilidade}</td>
 
                  <td>
                  {p.Estagio === 8 ? (
                    <button
                      style={{
                        background: "#4caf50",
                        color: "#fff",
                        border: 0,
                        borderRadius: 8,
                        padding: "4px 12px",
                        cursor: "pointer",
                        fontWeight: 600
                      }}
                      onClick={() => baixarContrato(p.id)}
                    >
                      Contrato
                    </button>
                  ) : (
                    <span style={{ color: "#aaa", fontSize: 12 }}>---</span>
                  )}
                </td>
                                     <td>
                    <button
                      style={{
                        background: "#00bcd4",
                        color: "#fff",
                        border: 0,
                        borderRadius: 8,
                        padding: "4px 12px",
                        cursor: "pointer",
                        fontWeight: 600,
                      }}
                      onClick={() => setExpandida(expandida === p.id ? null : p.id)}
                    >
                      {expandida === p.id ? "Fechar" : "Detalhes"}
                    </button>
                  </td>
                </tr>
                {expandida === p.id && (
                  <tr>
                    <td colSpan={13} style={{ background: "#f6fafd" }}>
                      <DetalheProposta id={p.id} formatData={formatData} calcularIdade={calcularIdade} onReload={handleReload}/>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))
          )}
        </tbody>
      </table>
      <div className="paginacao-pv" style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: 8
          }}>
            <button
              className="pv-btn-sec"
              disabled={pagina <= 1}
              onClick={() => setPagina(pagina - 1)}
              style={{ minWidth: 80, fontWeight: 600, opacity: pagina <= 1 ? 0.5 : 1 }}
            >Anterior</button>
            <span style={{ alignSelf: "center", fontWeight: 500, fontSize: 16, minWidth: 80, textAlign: "center" }}>
              Página {pagina}
            </span>
            <button
              className="pv-btn-sec"
              disabled={!temProximaPagina}
              onClick={() => setPagina(pagina + 1)}
              style={{ minWidth: 80, fontWeight: 600, opacity: !temProximaPagina ? 0.5 : 1 }}
            >Próxima</button>
          </div>

    </div>
  );
}

function DetalheProposta({ id, formatData, calcularIdade , onReload}) {
  const [detalhe, setDetalhe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showQuestionario, setShowQuestionario] = useState(false);
  const [depDetalheId, setDepDetalheId] = useState(null);
  const [anexosFamilia, setAnexosFamilia] = useState([]);
  const [showAnexos, setShowAnexos] = useState(false);
function baixarContrato(idProposta) {
  // Abre o PDF gerado pelo backend em uma nova aba
  window.open(`https://gerencial.vionia.com.br/api/contrato/${idProposta}`, "_blank");
}


const alterarEstagio = async (novoEstagio) => {
  try {
    await fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/estagio`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ estagio: novoEstagio }),
    });

    if (onReload) onReload(); // <- aqui!

    // Atualiza os dados no detalhe também, se quiser manter o box visível com dados atualizados:
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}`)
      .then(r => r.json())
      .then(setDetalhe);
  } catch (err) {
    console.error("Erro ao atualizar estágio", err);
    alert("Erro ao atualizar estágio.");
  }
};

async function finalizarProposta(titularId) {
  try {
    const response = await fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${titularId}`);
    const data = await response.json();
    const dependentes = data.dependentes || [];
    const ids = [titularId, ...dependentes.map(dep => dep.id)];

    await Promise.all(
      ids.map(id =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estagio: 8 })  // 8 = Concluída
        })
      )
    );

    alert("Proposta finalizada com sucesso!");
    onReload && onReload();
  } catch (err) {
    alert("Erro ao finalizar a proposta.");
    console.error(err);
  }
}

async function cancelarProposta(titularId) {
  const confirmacao = window.confirm("Esse processo não poderá ser desfeito. Tem certeza?");
  if (!confirmacao) return;

  try {
    const response = await fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${titularId}`);
    const data = await response.json();
    const dependentes = data.dependentes || [];
    const ids = [titularId, ...dependentes.map(dep => dep.id)];

    await Promise.all(
      ids.map(id =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estagio: 7 })  // 7 = Recusada
        })
      )
    );

    alert("Proposta cancelada!");
    onReload && onReload();
  } catch (err) {
    alert("Erro ao cancelar a proposta.");
    console.error(err);
  }
}

async function voltarParaAnalista(titularId) {
  try {
    const response = await fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${titularId}`);
    const data = await response.json();
    const dependentes = data.dependentes || [];
    const ids = [titularId, ...dependentes.map(dep => dep.id)];

    await Promise.all(
      ids.map(id =>
        fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/estagio`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ estagio: 3 })  // 3 = Analista
        })
      )
    );

    alert("Proposta retornada para o analista.");
    onReload && onReload();
  } catch (err) {
    alert("Erro ao retornar proposta.");
    console.error(err);
  }
}



  useEffect(() => {
    setLoading(true);
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}`)
      .then(r => r.json())
      .then(setDetalhe)
      .finally(() => setLoading(false));
  }, [id]);
  // Busca anexos da família (titular + dependentes)
useEffect(() => {
  fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/anexos_familia`)
    .then(r => r.json())
    .then(setAnexosFamilia)
    .catch(() => setAnexosFamilia([]));
}, [id]);

  if (loading) return <div style={{ padding: 24, color: "#888" }}>Carregando detalhes...</div>;
  if (!detalhe) return <div style={{ padding: 24, color: "#e04d4d" }}>Não encontrado.</div>;

  return (
    <div>
      <div className="pv-card">
        <div className="pv-section-title">Titular</div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            gap: 2,
            marginBottom: 10,
            alignItems: "center",
          }}
        >
          <div><b>Nome:</b> {detalhe.nome}</div>
          <div><b>CPF:</b> {detalhe.cpf}</div>
          <div><b>Data Nasc.:</b> {formatData(detalhe.data_nascimento)}
            {(() => {
              const idade = calcularIdade(detalhe.data_nascimento);
              return idade !== "" ? (
                <span className="pv-tag">{idade} anos</span>
              ) : null;
            })()}
          </div>
          <div><b>Nome Mãe:</b> {detalhe.nome_mae}</div>
          <div><b>Email:</b> {detalhe.email}</div>
          <div><b>Celular:</b> {detalhe.celular}</div>
          <div><b>Telefone:</b> {detalhe.telefone}</div>
          <div><b>CEP:</b> {detalhe.cep}</div>
          <div style={{ gridColumn: "span 4" }}>
            <b>Endereço:</b> {detalhe.rua}, {detalhe.numero}, {detalhe.complemento}
          </div>
          <div><b>Bairro:</b> {detalhe.bairro}</div>
          <div><b>Cidade:</b> {detalhe.cidade}/{detalhe.estado}</div>
          <div><b>Vendedor:</b> {detalhe.vendedor}</div>
          <div><b>Corretora:</b> {detalhe.corretora}</div>
          <div><b>Analista:</b> {detalhe.analista_nome || detalhe.analista}</div>
          <div><b>Médico:</b> {detalhe.medico_nome || detalhe.medico}</div>
          <div><b>Estágio:</b> {detalhe.estagio_nome || detalhe.Estagio}</div>
          <div><b>Portabilidade:</b> {detalhe.Portabilidade}</div>
          <div><b>Plano:</b> {detalhe.nome_plano || detalhe.produto_id}</div>
          <div>
          <b>Sexo:</b>{" "}
          {["M", "m", "H", "h"].includes((detalhe.sexo || "").toUpperCase())
            ? "Homem"
            : ["F", "f", "Mulher"].includes((detalhe.sexo || "").toUpperCase())
            ? "Mulher"
            : detalhe.sexo_descricao || detalhe.sexo || "-"}
        </div>
          <div><b>Peso:</b> {detalhe.peso} kg</div>
          <div><b>Altura:</b> {detalhe.altura} cm</div>
          <div><b>IMC:</b>{" "}
          {detalhe.peso && detalhe.altura
            ? (detalhe.peso / Math.pow(detalhe.altura / 100, 2)).toFixed(2)
            : ""}
        </div>
        </div>

        <div style={{ marginTop: 14, display: "flex", gap: 10 }}>
            {detalhe.questionario_id ? (
              <button
                className="pv-btn"
                onClick={() => setShowQuestionario(true)}
              >
                Ver Questionário Saúde
              </button>
            ) : (
              <span style={{ color: "#f9a825", fontWeight: 600, fontSize: 13, marginLeft: 8 }}>
                Sem questionário
              </span>
            )}
                {anexosFamilia.length > 0 && (
                  <button className="pv-btn-sec" onClick={() => setShowAnexos(true)}>
                      Anexos
                  </button>
              )}
            {/* BOTÃO ANEXOS, SÓ SE HOUVER ANEXO */}
            

          </div>

      </div>
      <div className="pv-card">
        <div className="pv-section-title">Dependentes</div>
        <table className="pv-list-table" style={{ marginBottom: 24 }}>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Parentesco</th>
              <th>Data Nasc.</th>
              <th>CPF</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {detalhe.dependentes.map(dep => (
              <tr key={dep.id}>
                <td>{dep.nome}</td>
                <td>{dep.parentesco_nome || dep.parentesco_id}</td>
                <td>
                  {formatData(dep.data_nascimento)}
                  {(() => {
                    const idade = calcularIdade(dep.data_nascimento);
                    return idade !== "" ? (
                      <span className="pv-tag">{idade} anos</span>
                    ) : null;
                  })()}
                </td>
                <td>{dep.cpf}</td>
                <td>
                  <button className="pv-btn-sec" onClick={() => setDepDetalheId(dep.id)}>
                    Detalhes
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {depDetalheId && (
        <ModalDependente id={depDetalheId} onClose={() => setDepDetalheId(null)} formatData={formatData} calcularIdade={calcularIdade} />
      )}
      {showQuestionario && (
        <ModalQuestionario
          id={id}
          onClose={() => setShowQuestionario(false)}
        />
      )}
            {depDetalheId && (
        <ModalDependente id={depDetalheId} onClose={() => setDepDetalheId(null)} formatData={formatData} calcularIdade={calcularIdade} />
      )}
      {showQuestionario && (
        <ModalQuestionario
          id={id}
          onClose={() => setShowQuestionario(false)}
        />
      )}
      {/* ADICIONE ESTA LINHA ABAIXO */}
      {showAnexos && (
        <ModalAnexos anexosFamilia={anexosFamilia} onClose={() => setShowAnexos(false)} />
      )}

    </div>
    
  );
  
}


function ModalDependente({ id, onClose, formatData, calcularIdade }) {
  const [detalhe, setDetalhe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showQuestionario, setShowQuestionario] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}`)
      .then(r => r.json())
      .then(setDetalhe)
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div style={{ padding: 24, color: "#888" }}>Carregando detalhes...</div>;
  if (!detalhe) return <div style={{ padding: 24, color: "#e04d4d" }}>Não encontrado.</div>;

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
      background: "rgba(0,0,0,0.36)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div className="pv-card" style={{ minWidth: 440, maxWidth: "92vw", maxHeight: "90vh", overflowY: "auto" }}>
        <h3 className="pv-section-title" style={{ marginTop: 0 }}>Detalhes do Dependente</h3>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
            gap: 2,
            marginBottom: 10,
            alignItems: "center",
          }}
        >
          <div><b>Nome:</b> {detalhe.nome}</div>
          <div><b>Parentesco:</b> {detalhe.parentesco_nome || detalhe.parentesco_id}</div>
          <div>
            <b>Data Nasc.:</b> {formatData(detalhe.data_nascimento)}
            {(() => {
              const idade = calcularIdade(detalhe.data_nascimento);
              return idade !== "" ? (
                <span className="pv-tag">{idade} anos</span>
              ) : null;
            })()}
          </div>
          <div><b>CPF:</b> {detalhe.cpf}</div>
          <div><b>Email:</b> {detalhe.email}</div>
          <div><b>Telefone:</b> {detalhe.telefone}</div>
          <div><b>Celular:</b> {detalhe.celular}</div>
          <div><b>Plano:</b> {detalhe.nome_plano || detalhe.produto_id}</div>
          <div><b>Analista:</b> {detalhe.analista_nome || detalhe.analista}</div>
          <div><b>Médico:</b> {detalhe.medico_nome || detalhe.medico}</div>
          <div>
          <b>Sexo:</b>{" "}
          {["M", "m", "H", "h"].includes((detalhe.sexo || "").toUpperCase())
            ? "Homem"
            : ["F", "f", "Mulher"].includes((detalhe.sexo || "").toUpperCase())
            ? "Mulher"
            : detalhe.sexo_descricao || detalhe.sexo || "-"}
        </div>
          <div><b>Peso:</b> {detalhe.peso} kg</div>
          <div><b>Altura:</b> {detalhe.altura} cm</div>
          <div><b>IMC:</b>{" "}{detalhe.peso && detalhe.altura
              ? (detalhe.peso / Math.pow(detalhe.altura / 100, 2)).toFixed(2)
              : ""}
</div>
        </div>

        <div style={{ marginTop: 10, display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={onClose}
            className="pv-btn"
          >
            Fechar
          </button>
          {detalhe.questionario_id && (
            <button
              className="pv-btn-sec"
              style={{ marginLeft: 12 }}
              onClick={() => setShowQuestionario(true)}
            >
              Ver Questionário Saúde
            </button>
          )}
        </div>
        {showQuestionario && (
          <ModalQuestionario
            id={id}
            onClose={() => setShowQuestionario(false)}
          />
        )}
      </div>
    </div>
  );
}

function ModalQuestionario({ id, onClose }) {
  const [quest, setQuest] = useState([]);
  const [beneficiario, setBeneficiario] = useState(null);

  // Carrega o questionário
  useEffect(() => {
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}/questionario`)
      .then(r => r.json())
      .then(setQuest)
      .catch(() => setQuest([]));
  }, [id]);

  // Carrega os dados do beneficiário
  useEffect(() => {
    fetch(`https://gerencial.vionia.com.br/api/beneficiarios/${id}`)
      .then(r => r.json())
      .then(setBeneficiario)
      .catch(() => setBeneficiario(null));
  }, [id]);

  // Função de imprimir
  const handlePrint = () => {
  window.print();
};

return (
  <div style={{
    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
    background: "rgba(0,0,0,0.36)", zIndex: 99, display: "flex", alignItems: "center", justifyContent: "center"
  }}>
    <div style={{
      background: "#fff", borderRadius: 16, padding: 28, minWidth: 380,
      maxWidth: "90vw", maxHeight: "90vh", overflowY: "auto"
    }}>
      {/* Botões */}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginBottom: 8 }}>
        <button
          onClick={handlePrint}
          className="pv-btn-sec"
        >
          Imprimir
        </button>
        <button
          style={{
            background: "#00bcd4",
            color: "#fff",
            border: 0,
            borderRadius: 8,
            padding: "8px 30px",
            fontWeight: 600,
            cursor: "pointer"
          }}
          onClick={onClose}
        >Fechar</button>
      </div>
      {/* ÁREA DE IMPRESSÃO */}
      <div className="print-area" style={{ position: "relative", minHeight: 620 }}>
        <img src={logo} alt="Logo" style={{ width: 160, display: "block", margin: "0 auto 24px auto" }} />
        <h2 style={{ margin: "0 0 12px 0", textAlign: "center" }}>
          {beneficiario?.corretora || beneficiario?.operadora || "Operadora/Corretora"}
        </h2>
        <h3 style={{ margin: "0 0 22px 0", fontWeight: 600, textAlign: "center" }}>Questionário de Saúde</h3>
        <div style={{ marginBottom: 18, fontSize: 16 }}>
          <b>Nome:</b> {beneficiario?.nome || "-"}<br />
          <b>CPF:</b> {beneficiario?.cpf || "-"}<br />
          <b>Plano:</b> {beneficiario?.nome_plano || beneficiario?.produto_id || "-"}
        </div>
        {quest.length === 0 ? (
          <div style={{ color: "#888", textAlign: "center" }}>Nenhuma resposta encontrada.</div>
        ) : (
          <table style={{ width: "100%", background: "#f9fafd", borderRadius: 8, fontSize: 16 }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: "8px" }}>Pergunta</th>
                <th style={{ textAlign: "left", padding: "8px" }}>Resposta</th>
              </tr>
            </thead>
            <tbody>
              {quest.map(q => (
                <tr key={q.pergunta_id}>
                  <td style={{ padding: "8px 8px 8px 0" }}>{q.pergunta}</td>
                  <td style={{ padding: "8px" }}>{q.resposta}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* RODAPÉ IMPRESSO */}
        <div className="print-footer" style={{
          position: "fixed",
          bottom: 16,
          left: 0,
          width: "100vw",
          display: "flex",
          alignItems: "center",
          fontSize: 14,
          color: "#888",
          justifyContent: "space-between",
          padding: "0 44px",
          zIndex: 99999,
          background: "transparent",
          boxSizing: "border-box"
        }}>
          <div>
            {''}
          </div>
          <div className="print-footer-center" style={{
            flex: 1,
            textAlign: "center",
            fontSize: 13,
            color: "#888",
            letterSpacing: 1
          }}>
            Conectaai.tech
          </div>
          <div>
            {new Date().toLocaleString('pt-BR')}
          </div>
        </div>
      </div>
    </div>
  </div>
);
}
function ModalAnexos({ anexosFamilia, onClose }) {
  // Agrupa por nome do beneficiário
  const grupos = anexosFamilia.reduce((acc, anexo) => {
    if (!acc[anexo.nome]) acc[anexo.nome] = [];
    acc[anexo.nome].push(anexo);
    return acc;
  }, {});

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
      background: "rgba(0,0,0,0.36)", zIndex: 999, display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div className="pv-card" style={{ minWidth: 400, maxWidth: "92vw", maxHeight: "90vh", overflowY: "auto" }}>
        <h3 className="pv-section-title" style={{ marginTop: 0 }}>Anexos da Família</h3>
        {Object.keys(grupos).length === 0 ? (
          <div style={{ color: "#888", marginBottom: 12 }}>Nenhum anexo encontrado.</div>
        ) : (
          Object.keys(grupos).map(nome => (
            <div key={nome} style={{ marginBottom: 18 }}>
              <b style={{ color: "#1976d2" }}>{nome}</b>
              <ul style={{ margin: "4px 0 0 18px", padding: 0 }}>
                {grupos[nome].map(ax => (
                  <li key={ax.caminho} style={{ marginBottom: 2, listStyle: "disc" }}>
                    <a
                      href={`https://gerencial.vionia.com.br/api/anexos/${encodeURIComponent(ax.caminho)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {ax.caminho.split(/[\\/]/).pop()}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))
        )}
        <button className="pv-btn" onClick={onClose} style={{ marginTop: 16 }}>Fechar</button>
      </div>
    </div>
  );
}





export default FinalizadoView;
